// extracted by mini-css-extract-plugin
module.exports = {"box":"Specs_box__1Vzaq","title":"Specs_title__3TApI","desc":"Specs_desc__13afw","content":"Specs_content__1SfN7"};